// extracted by mini-css-extract-plugin
export default {"main_title":"Overview_main_title__Pq8wD"};